// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3j4dz","inputDescription":"styles_inputDescription__3ny4V"};